import Icon from 'veui/components/Icon'
import { IconChevronDoubleUp } from 'dls-icons-vue'

Icon.register('chevron-double-up', IconChevronDoubleUp)
